import { flow, types as t } from 'mobx-state-tree';

import api from 'api';

import Job from './Job';
import StoreState from './StoreState';
import uiStore from './UIStore';

const JobStore = t
  .model('JobStore', {
    company: t.maybe(t.string),
    items: t.map(Job),
    state: t.optional(StoreState, 'initial'),
  })
  .views((self) => ({
    get allJobs() {
      return Array.from(self.items.values());
    },
    get jobs() {
      return self.allJobs.filter(
        (job) =>
          job.languages.find((l) => l.language === uiStore.language) && job.visibility === 'public'
      );
    },
  }))
  .actions((self) => ({
    setCurrent(companyName) {
      self.company = companyName;
      self.load();
    },
    addOrUpdate(job) {
      const curr = self.items.get(job.id);

      if (!curr) {
        self.items.put(job);
      } else {
        self.items.put({ ...curr, ...job });
      }
    },
    load: flow(function* () {
      if (self.state !== 'initial') return;
      self.state = 'loading';

      const res = yield api.jobs.load(self.company);
      if (!res.error) {
        res.data.forEach((job) => {
          job.languages = job.languages.map((jl) => {
            if (!jl.shortDescriptionHtml) {
              jl.shortDescriptionHtml = jl.shortDescription;
            }
            return jl;
          });
          self.addOrUpdate(job);
        });
      }
      self.state = 'loaded';
    }),
  }))
  .views((self) => ({}));

export { JobStore };
export default JobStore.create();
